module.exports = __webpack_public_path__ + "src/assets/img/brand-01.jpg";